import flower from '../../images/quote/flower.svg'
import quote1 from '../../images/quote/image-1.jpg'
import quote2 from '../../images/quote/image-2.jpg'
import quote3 from '../../images/quote/image-3.jpg'
import quote4 from '../../images/quote/image-4.jpg'


const Quote: React.FC = () => {
    
    return (
        <section className="wpo-quote-section">
            <div className="container">
                <div className="quote-wrap">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-12">
                            <div className="quote-title">
                                <h2 className="poort-text poort-in-right">"I walk beside you"</h2>
                                <p>Hace más de diez años que esta historia comenzó, y hoy, después de todo lo vivido, 
                                    podemos decir que cada día es un nuevo capítulo lleno de amor, risas y aventuras. 
                                    Hemos compartido momentos inolvidables, superado desafíos juntos y construido una vida llena de felicidad. 
                                    Nuestro amor ha crecido con el tiempo, fortaleciéndose con cada experiencia compartida. 
                                    Estamos emocionados por lo que el futuro nos depara, sabiendo que juntos podemos enfrentar cualquier cosa que la vida nos presente. 
                                    Te amo más de lo que las palabras pueden expresar, y estoy agradecido por cada día que compartimos juntos.
                                    </p>
                                <div className="flower">
                                    <img src={flower} alt="flower"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="left-images">
                <div className="image-1 wow fadeInDown" data-wow-duration="1200ms">
                    <div className="image-move">
                        <img src={quote1} alt=""/>
                    </div>
                </div>
                <div className="image-2 wow fadeInUp" data-wow-duration="1200ms">
                    <div className="image-move">
                        <img src={quote2} alt=""/>
                    </div>
                </div>

            </div>
            <div className="right-images">
                <div className="image-1 wow fadeInDown" data-wow-duration="1200ms">
                    <div className="image-move2">
                        <img src={quote4} alt=""/>
                    </div>
                </div>
                <div className="image-2 wow fadeInRight" data-wow-duration="1200ms">
                    <div className="image-move2">
                        <img src={quote3} alt=""/>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Quote;